(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-free-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-free-shipping')) {
    class ProductFreeShipping extends HTMLElement {
      connectedCallback() {
        this.drawer = document.querySelector('cart-drawer');
        this.button = this.closest('form')?.querySelector('.product-form__submit');
        if (!this.drawer || !this.button) return;

        this.message = this.querySelector('[data-product-shipping-message]');
        this.domState = undefined;
        this.onAdded = () => this.sync();
        document.addEventListener('ajaxProduct:added', this.onAdded);
        this.onCartUpdate = (event) => this.sync(event.cart || event.detail?.cart);
        document.addEventListener('cart:updated', this.onCartUpdate);
        this.cartObserver = new MutationObserver(() => this.sync());
        this.observeDrawer();
        this.resizeObserver = new ResizeObserver(() => this.align());
        this.resizeObserver.observe(this.button);
        this.resizeObserver.observe(this.parentElement);
        this.desktopLayout = window.matchMedia('(min-width: 768px)');
        this.onLayoutChange = () => this.align();
        this.desktopLayout.addEventListener('change', this.onLayoutChange);
        this.subscribeToCart();
        if (!this.unsubscribe) {
          customElements.whenDefined('cart-items').then(() => {
            if (this.isConnected) {
              this.subscribeToCart();
              this.sync();
            }
          });
        }
        this.onPageShow = (event) => {
          if (event.persisted) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
          }
        };
        window.addEventListener('pageshow', this.onPageShow);
        this.sync();
      }

      subscribeToCart() {
        if (!this.unsubscribe && typeof theme !== 'undefined' && theme.pubsub?.subscribe) {
          this.unsubscribe = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('ajaxProduct:added', this.onAdded);
        document.removeEventListener('cart:updated', this.onCartUpdate);
        window.removeEventListener('pageshow', this.onPageShow);
        this.unsubscribe?.();
        this.unsubscribe = undefined;
        this.cartObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.desktopLayout?.removeEventListener('change', this.onLayoutChange);
      }

      observeDrawer() {
        this.cartObserver.disconnect();
        if (this.drawer) {
          this.cartObserver.observe(this.drawer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-item-count', 'data-unlocked'],
            characterData: true
          });
        }
      }

      sync(cart) {
        if (cart?.errors || cart?.status) return;
        const drawer = document.querySelector('cart-drawer');
        if (drawer !== this.drawer) {
          this.drawer = drawer;
          this.observeDrawer();
        }

        const renderedState = this.drawer?.querySelector('template[data-product-shipping-state]');
        const domState = renderedState?.outerHTML || '';
        if (!cart && domState === this.domState) return;
        this.domState = domState;

        const sectionHTML = cart?.sections?.[this.drawer?.dataset.sectionId];
        const source = typeof sectionHTML === 'string'
          ? new DOMParser().parseFromString(sectionHTML, 'text/html')
          : this.drawer;
        const state = source?.querySelector('template[data-product-shipping-state]');
        this.hidden = !state || cart?.item_count === 0 || Number(state.dataset.itemCount) === 0;
        if (this.hidden) {
          delete this.dataset.unlocked;
          this.message.replaceChildren();
          return;
        }

        this.dataset.unlocked = state.dataset.unlocked;
        if (this.message.innerHTML !== state.innerHTML) {
          this.message.replaceChildren(state.content.cloneNode(true));
        }
        this.align();
      }

      align() {
        if (this.hidden || !this.desktopLayout?.matches) return;
        const button = this.button.getBoundingClientRect();
        const widget = this.getBoundingClientRect();
        const inset = Math.min(16, button.width * 0.05);
        this.style.setProperty('--shipping-width', `${Math.max(0, button.width - inset * 2)}px`);
        this.style.setProperty('--shipping-left', `${button.left - widget.left + inset}px`);
      }
    }

    customElements.define('product-free-shipping', ProductFreeShipping);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-pack-selector')) {
    customElements.define('product-pack-selector', class extends HTMLElement {
      get form() {
        return document.getElementById(this.getAttribute('form'));
      }

      get input() {
        return this.form?.elements.namedItem('quantity');
      }

      connectedCallback() {
        this.info = this.closest('product-info');
        if (!this.info) return;
        this.variantPrices = JSON.parse(this.querySelector('[data-pack-prices]')?.textContent || '{}');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.onQuantity = (event) => {
          if (event.target === this.input || event.target === this.form?.elements.namedItem('id')) this.sync();
        };
        this.info.addEventListener('input', this.onQuantity, options);
        this.info.addEventListener('change', this.onQuantity, options);
        this.info.addEventListener('product-info:loaded', () => this.sync(), options);
        this.info.addEventListener('skio::update-selling-plan', () => this.syncPrices(), options);
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-quantity]');
          if (!button || button.disabled || !this.input) return;
          this.sync();
          if (button.disabled) return;
          this.input.value = button.dataset.quantity;
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          this.sync();
        }, options);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.info, { subtree: true, childList: true, attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled', 'value'] });
        this.unsubscribers = [];
        customElements.whenDefined('quantity-input').then(() => {
          if (!this.isConnected) return;
          const pubsub = window.theme?.pubsub;
          if (!pubsub) return;
          this.unsubscribers.push(pubsub.subscribe(pubsub.PUB_SUB_EVENTS.quantityUpdate, () => this.sync()));
          this.unsubscribers.push(pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.info.sectionId || data.productId !== this.info.productId) return;
            const updatedInfo = data.parsedHTML.getElementById(this.info.id);
            if (this.contains(this.input)) {
              const updatedInput = updatedInfo?.querySelector('product-pack-selector input[name="quantity"]');
              if (updatedInput) {
                ['min', 'max', 'step'].forEach((attribute) => {
                  const value = updatedInput.getAttribute(attribute);
                  if (value === null) this.input.removeAttribute(attribute);
                  else this.input.setAttribute(attribute, value);
                });
              }
            }
            this.info.querySelectorAll('[options]').forEach((picker) => {
              if (!('quantity' in picker)) return;
              const updated = Array.from(updatedInfo?.querySelectorAll('[options]') || []).find((element) => element.getAttribute('key') === picker.getAttribute('key'));
              if (updated) {
                const servings = JSON.parse(updated.getAttribute('options')).servings_per_unit;
                if (servings !== picker.options.servings_per_unit) picker.options = { ...picker.options, servings_per_unit: servings };
              }
            });
            this.sync();
          }));
          this.sync();
        });
        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
      }

      syncPrices() {
        const picker = Array.from(this.info.querySelectorAll('[options]')).find((element) => element.form === this.form && typeof element.price === 'function');
        const quantity = Number(this.input?.value) || 1;
        const variant = this.variantPrices[this.form?.elements.namedItem('id')?.value];
        const scope = this.closest('.shopify-section') || this.info;
        scope.querySelectorAll('product-buy-price').forEach((price) => {
          if (price.productForm !== this.form) return;
          const base = variant?.price ?? price.basePrice;
          price.unitPrice = picker?.selectedVariant
            ? picker.price(picker.selectedSellingPlan, false)
            : quantity === 2 ? Math.round(base * quantity * (100 - Number(this.dataset.packDiscount)) / 100) / quantity : base;
          price.render?.();
        });
        if (picker) picker.updateExternalPrice?.();
        else if (window.theme?.Currency) {
          if (variant) {
            const unit = quantity === 2 ? Math.round(variant.price * quantity * (100 - Number(this.dataset.packDiscount)) / 100) / quantity : variant.price;
            const format = theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat;
            this.info.querySelectorAll('[id^="Price-"] .price__regular').forEach((element) => {
              element.innerHTML = theme.Currency.formatMoney(unit, format);
            });
          }
          const sticky = scope.querySelector('product-sticky-form');
          if (sticky && variant) {
            const total = quantity === 2 ? Math.round(variant.price * quantity * (100 - Number(this.dataset.packDiscount)) / 100) : variant.price * quantity;
            const format = theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat;
            sticky.querySelectorAll('.price__regular .price-item, .price__regular [data-price]').forEach((element) => {
              element.innerHTML = theme.Currency.formatMoney(total, format);
            });
            if (variant.compare_at_price > variant.price) sticky.querySelectorAll('.price__sale').forEach((element) => {
              element.innerHTML = theme.Currency.formatMoney(variant.compare_at_price * quantity, format);
            });
          }
        }
      }

      sync() {
        const input = this.input;
        if (!input) return;
        const quantity = Number(input.value);
        const min = input.min === '' ? 1 : Number(input.min);
        const max = input.max === '' ? Infinity : Number(input.max);
        const step = input.step === 'any' ? 0 : Number(input.step || 1);
        const unavailable = input.disabled || this.form?.querySelector('[type="submit"]')?.disabled;
        this.querySelectorAll('button[data-quantity]').forEach((button) => {
          const value = Number(button.dataset.quantity);
          const disabled = unavailable || value < min || value > max || (step > 0 && (value - min) % step !== 0);
          if (button.disabled !== Boolean(disabled)) button.disabled = Boolean(disabled);
          const selected = String(value === quantity);
          if (button.getAttribute('aria-pressed') !== selected) button.setAttribute('aria-pressed', selected);
        });
        this.info.querySelectorAll('[options]').forEach((picker) => {
          if ('quantity' in picker && picker.form === this.form && picker.quantity !== quantity) picker.quantity = quantity;
        });
        const variant = this.form?.elements.namedItem('id')?.value;
        const scope = this.closest('.shopify-section') || this.info;
        const priceNodes = Array.from(scope.querySelectorAll('product-buy-price, product-sticky-form [data-price], [id^="Price-"] .price__regular'));
        const pricesReplaced = !this.priceNodes || priceNodes.length !== this.priceNodes.length || priceNodes.some((node, index) => node !== this.priceNodes[index]);
        if (this.lastQuantity !== quantity || this.lastVariant !== variant || pricesReplaced) {
          this.priceNodes = priceNodes;
          this.lastQuantity = quantity;
          this.lastVariant = variant;
          this.syncPrices();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
